<template>
  <div>
    <b-row>
      <b-col>
        <div id="map"></div>
        <div class="float-right mt-2">
          <button type="button" class="btn btn-primary rounded mr-1 btn-lg" @click="closeMap">Cancel</button>
          <button type="button" class="btn btn-outline-primary rounded btn-lg" @click="saveTradezone">Save</button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script type="text/javascript">
  let vm = null
export default {
	props: ['lat','long','markers','getpaths', 'subpaths', 'outlet'],
	data() {
		return {
			paths : [],
			selectedShape : {},
			map : {},
			drawingManager : {},
			colors : ['green','red'],
			infoWindow:{},
			vertex: '',
			polygon: '',
      newPolygon: [],
      overlaps: [],
      outletList: [],
      nearbyOutlets: [],
      nearbyOutletsTradezones: [],
      nearbyOutletsMarker: [],
      undo: [],
      redo: []
		}
	},
	mounted(){
		this.$root.$on('bv::modal::shown',async () => {
        vm.nearbyOutlets = await vm.getNearbyOutlets();
        this.refreshMap();
    })
	},
	async created(){
    vm = this;
    vm.outletUuid = vm.$route.params.uuid;
    // vm.getStoreList();

		window.viewListSubtradezone = (tradezoneId) => {
		this.$router.push({name: 'subtradezones', params: { id: tradezoneId }})
		},
		window.manageTradezone = () => {
			const uuid = this.$route.params.uuid;
			this.$router.push({name: 'tradezone_list', params: { uuid: uuid }})
		},
		window.removeTradezone = (tradezoneId) => {
      const options = {
        html: true,
        okText: this.$t('common.delete'),
        cancelText: this.$t('common.cancel')
      }
      this.$dialog.confirm(this.$t('message.delete_confirm'), options)
        .then((dialog) => {
            this.axios.outlet.deleteTradezone(tradezoneId, (response) => {
                this.$toastr.success(this.$t('message.update_successful'), this.$t('message.success'), {})
								this.$bus.$emit('loading', 'none')
								setTimeout(() => {
									window.location.reload();
								}, 1500);
            }, () => {
                this.$toastr.error(this.$t('message.error'), this.$t('message.success'), {})
                this.$bus.$emit('loading', 'none')
            })
        })
        .catch((error) => {
					console.log('delete error', error);
        })
    },
    window.removeVertex = () => {
      let path = vm.selectedShape.getPath();
      path.removeAt(vm.vertex);
      vm.infoWindow.close();
      vm.getPolygonCoords(vm.polygon);
    }
	},
	methods : {
		/**
		 * Clear selected shape
		 */
		clearSelection () {
		    if (this.selectedShape) {
		        if (this.selectedShape.type !== 'marker') {
		            this.selectedShape.setEditable(true);
		        }
		        this.selectedShape = null;
		    }
		},
		/**
		 * Set shape when clicked
		 */
		setSelection (shape) {
		    if (shape.type !== 'marker') {
		        this.clearSelection();
		        shape.setEditable(true);
		        this.selectColor(shape.get('fillColor') || shape.get('strokeColor'));
		    }

		    this.selectedShape = shape;
		},
		/**
		 * Select color shape
		 */
		selectColor (color) {
		    // Retrieves the current options from the drawing manager and replaces the
		    // stroke or fill color as appropriate.
		    var polylineOptions = this.drawingManager.get('polylineOptions');
		    polylineOptions.strokeColor = this.color;
		    this.drawingManager.set('polylineOptions', polylineOptions);

		    var polygonOptions = this.drawingManager.get('polygonOptions');
		    polygonOptions.fillColor = color;
		    this.drawingManager.set('polygonOptions', polygonOptions);
		},

    /**
     * Set color shape
     */
    setSelectedShapeColor(color) {
      if (this.selectedShape) {
        if (
          this.selectedShape.type == google.maps.drawing.OverlayType.POLYLINE
        ) {
          this.selectedShape.set("strokeColor", color);
        } else {
          this.selectedShape.set("fillColor", color);
        }
      }
    },
    /**
     * Build color when load map
     */
    buildColorPalette(color) {
      this.selectColor(color);
    },

    initPolygon(
      _map = {},
      _paths = [],
      _color = "",
      polygonCustomOptions = {}
    ) {
      return new google.maps.Polygon({
        paths: _paths,
        strokeColor: _color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: _color,
        fillOpacity: 0.35,
        map: _map,
        ...polygonCustomOptions
      });
    },

    /**
     * Refesh map
     */
    async refreshMap() {
			var myLatLng = {lat : vm.lat,lng : vm.long};
			let outlet = vm.outlet ? vm.outlet : {};

			// Create new Map
			vm.map = new google.maps.Map(document.getElementById('map'), {
				zoom: 12,
				center: new google.maps.LatLng(myLatLng),
				disableDefaultUI: true,
				zoomControl: true
			});
			google.maps.event.addListener(vm.map, 'zoom_changed', async function (e) {
        vm.nearbyOutletsMarker.forEach((marker) => {
				  marker.setMap(null);
				});
        vm.nearbyOutletsMarker = [];
        vm.nearbyOutletsTradezones.forEach((tradezone) => {
				  tradezone.setMap(null);
				});
        vm.nearbyOutletsTradezones = [];
				let zoom = parseInt(vm.map.getZoom());
        let distance = zoom >= 13 ? 10 : ( zoom < 10 ? 100 * (10 - zoom) : (zoom == 10 ? 50 : 30 - zoom));
        if (zoom <= 13) {
          vm.nearbyOutlets = await vm.getNearbyOutlets(distance);
        }
        vm.drawNearbyOutlets();
			});

			vm.infoWindow = new google.maps.InfoWindow;

			var polyOptions = {
				strokeWeight: 0,
				fillOpacity: 0.45,
				editable: true,
				draggable: false // do not enable this, it could cause loop event
			};

			vm.drawingManager = new google.maps.drawing.DrawingManager({
			drawingMode: google.maps.drawing.OverlayType.POLYGON,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: [
					google.maps.drawing.OverlayType.POLYGON
				]
			},
					markerOptions: {
							draggable: true
					},
					polylineOptions: {
							editable: true,
							draggable: true
					},
					polygonOptions: polyOptions,
					map: vm.map,
					drawingControl: true
			});
			let markerInfo = {
				name: outlet.name && outlet.name.en ? outlet.name.en : typeof outlet.name === 'string' ? outlet.name : '',
				email: outlet.email,
				address: outlet.address && outlet.address.en ? outlet.address.en : '',
				phone: outlet.phone,
				label: 'A'
			}
      // Main outlet's marker
			let marker = vm.addMarker(myLatLng, markerInfo)

      vm.drawNearbyOutlets();

			google.maps.event.addListener(vm.drawingManager, 'overlaycomplete', async function (e) {
				let newShape = e.overlay;
				newShape.type = e.type;
				vm.selectedShape = newShape;
				if (e.type !== google.maps.drawing.OverlayType.MARKER) {
					vm.drawingManager.setDrawingMode(null);
					vm.setSelection(newShape);
					const newPaths = {
						id: null,
						coords: []
					};
					for(var a in e.overlay.getPath().getArray()){
						newPaths.coords.push({lat : e.overlay.getPath().getArray()[a].lat(),lng : e.overlay.getPath().getArray()[a].lng()})
					}

					let currentTriangle = new google.maps.Polygon({paths: newPaths.coords});
					let currentPosition=new google.maps.LatLng(myLatLng);
					if(!google.maps.geometry.poly.containsLocation(currentPosition, currentTriangle)){
						vm.selectedShape.setOptions({fillColor: 'red'});
						vm.openInfoWindowPolygon(e.overlay,'Make sure to include the hut inside the delivery area.')
					} else {
						if (newPaths && newPaths.coords && newPaths.coords.length >= 3) {
							let fullPaths = { coords: [...newPaths.coords, newPaths.coords[0]] };
							let handleOverlap = await vm.handleOverlap(fullPaths);

							if (!handleOverlap) {
								vm.selectedShape.setOptions({fillColor: 'blue'});
								if(vm._.isEmpty(vm.paths)) {
									vm.paths = [...vm.getpaths];
								}

								vm.paths.push(newPaths);
							}
						}
					}
					google.maps.event.addListener(e.overlay.getPath(), "insert_at", vm.getPolygonCoords.bind(this, newPaths));
					google.maps.event.addListener(e.overlay.getPath(), "set_at", vm.getPolygonCoords.bind(this, newPaths));

				} else {
					google.maps.event.addListener(newShape, 'click', function (e) {
							setSelection(newShape);
					});
					setSelection(newShape);
				}
				if(vm.paths && vm.paths.length > 0) {
					let currentTriangle = new google.maps.Polygon({paths: vm._.last(vm.paths).coords});
					let currentPosition=new google.maps.LatLng(myLatLng);
					if(!google.maps.geometry.poly.containsLocation(currentPosition, currentTriangle)){
						vm.selectedShape.setOptions({fillColor: 'red',strokeColor:'red'});
						vm.openInfoWindowPolygon(vm.selectedShape,'Make sure to include the hut inside the delivery area.')
					} else {
						vm.setPathsMap(vm.paths);
					}
				}

				// google.maps.event.addListener(e.overlay.getPath(), "insert_at", vm.getPolygonCoords);
				// google.maps.event.addListener(e.overlay.getPath(), "set_at", vm.getPolygonCoords);
			});
			if(Object.keys(vm.getpaths).length != 0){
				if (vm._.isArray(vm.getpaths)) {
					vm.getpaths.forEach((path = {}) => {
						vm.paths.push(path);
						const content = `<div id="content-map-outlet">
							<h4>Tradezone ID:      <strong>${path.id}</strong></h4>
							<div class="mt-1 mb-1">
								<button class="btn-primary" onclick="viewListSubtradezone(${path.id})">View Subtradezones</button>
								<button class="btn-danger" onclick="removeTradezone(${path.id})">Delete</button>
							</div>
						</div>`;
						vm.polygonEffect(path, content, 'green');
					})
				}
			}

			// Just generate for list trade zone
			if (vm.subpaths) vm.subpaths.forEach((subpath = {}) => {
				vm.initPolygon(vm.map, subpath.coords, subpath.is_delivery ? 'green' : 'red');
				const content = `<div id="content-map-outlet">
						<h3><strong>Subtradezone</strong></h3>
						<div class="container">
							<div class="row">
								<div class="col-md font-weight-bold">
									ID
								</div>
								<div class="col-md">
									${subpath.id}
								</div>
							</div>
							<div class="row">
								<div class="col-md font-weight-bold">
									Name
								</div>
								<div class="col-md">
									${subpath.name}
								</div>
							</div>
							<div class="row">
								<div class="col-md font-weight-bold">
									Delivery Fee
								</div>
								<div class="col-md">
									${subpath.delivery_fee}
								</div>
							</div>
							<div class="row">
								<div class="col-md font-weight-bold">
									Delivery Time
								</div>
								<div class="col-md">
									${subpath.delivery_time}
								</div>
							</div>
						</div>
					</div>`;
          vm.polygonEffect(
            subpath,
            content,
            subpath.is_delivery ? "green" : "red"
          );
        }
      );
      // Clear the current selection when the drawing mode is changed, or when the map is clicked.
      google.maps.event.addListener(
        vm.drawingManager,
        "drawingmode_changed",
        vm.clearSelection
      );
      google.maps.event.addListener(vm.map, "click", vm.clearSelection);

      vm.buildColorPalette("green");
    },
    /**
     * show message info when user move polygon
     */
    openInfoWindowPolygon(polygon, message) {
      let vertices = polygon.getPath();

      var bounds = new google.maps.LatLngBounds();
      vertices.forEach(function(xy, i) {
        bounds.extend(xy);
      });

			vm.infoWindow.setContent(message);
			vm.infoWindow.setPosition(bounds.getCenter());
			vm.infoWindow.open(vm.map);
		},
		/**
		 * Check overlap polygon
		 */
		handleOverlap: async function (fullPaths) {
			let overlapPolygon = await vm.checkOverlap(fullPaths);
			let filterOverlapPolygon = vm._.filter(overlapPolygon, function (el) {
 				return fullPaths.id !== el.id;
			});
			if (filterOverlapPolygon && filterOverlapPolygon.length > 0) {
				vm.selectedShape.setOptions({fillColor: 'red'});
				vm.openInfoWindowPolygon(vm.selectedShape,'The new delivery area is overlapping with the delivery area of other Store. Please review.')
				// Remove unnecessary overlap polygons from map
				vm.overlaps.forEach((overlap) => {
				  overlap.setMap(null);
				});
				vm.overlaps = [];
				filterOverlapPolygon.forEach((path = {}) => {
					if(path && path.id != fullPaths.id) {
						const content = `<div id="content-map-outlet">
						<h4>Tradezone ID:      <strong>${path.id || ''}</strong></h4>
						<h4>Outlet ID:      <strong>${path.outlet_id || ''}</strong></h4>
						<h4>Outlet Code:      <strong>${path.outlet_code || ''}</strong></h4>
						<h4>Outlet Name:      <strong>${path.name ? path.name.en || '' : ''}</strong></h4>
						</div>`;
						// vm.polygonEffect(path, content, 'yellow', false);

						let overlap = vm.initPolygon(vm.map, path.coords, 'yellow', {});
						// Add a listener for the click tradezone event.
						google.maps.event.addListener(overlap, 'click', (event) => {
							let bounds = new google.maps.LatLngBounds();
							path.coords.forEach(function(xy, i) {
								bounds.extend(xy);
							});
							vm.infoWindow.setContent(content);
							vm.infoWindow.setPosition(event.latLng);
							vm.infoWindow.open(vm.map, overlap);
					});
            vm.overlaps.push(overlap);
					}
				});

				return true;
			} else {
        vm.$toastr.success('Delivery area is created correctly', vm.$t('message.success'), {})
        return false;
      }
		},
		/**
		 * Get latlng when edit polygon
		 */
		getPolygonCoords: async function (polygon){
			let vm=this
			let currentPosition=new google.maps.LatLng({lat : vm.lat,lng : vm.long});
			let flag=google.maps.geometry.poly.containsLocation(currentPosition, vm.selectedShape)
			if(flag && flag==true){
				const path =  vm.selectedShape.getPath().getArray().map(e => {
					return {
						lat: e.lat(), lng: e.lng()
					};
				});

				let handleOverlap = await vm.handleOverlap({coords: [...path, path[0]], id: polygon && polygon.id ? polygon.id : null});

				if(!handleOverlap) {
					vm.selectedShape.setOptions({fillColor: 'green',strokeColor:'green'});
					vm.openInfoWindowPolygon(vm.selectedShape,'Delivery area is created correctly.');
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})

					if(polygon && vm._.find(vm.paths, (e) => { return e.id === polygon.id })) {
						vm._.find(vm.paths, (e) => { return e.id === polygon.id }).coords = path;
					} else {
						const newPath = {
							id: null,
							coords: path
						};
						vm.paths.push[newPath];
					}
          vm.updatePathsMap(vm.paths);
          // Remove unnecessary overlap polygons from map
          vm.overlaps.forEach((overlap) => {
            overlap.setMap(null)
          });
				}
			}
			else{
				vm.selectedShape.setOptions({fillColor: 'red',strokeColor:'red'});
				vm.openInfoWindowPolygon(vm.selectedShape,'Make sure to include the hut inside the delivery area.')
			}
		},
		updatePathsMap(paths) {
			this.$root.$emit('updatePathsMap',paths);
		},
		/**
		 * set trade zone in main page
		 */
		setPathsMap(paths){
			this.$root.$emit('paths',paths);
		},
		/**
		 * set highlight when mouseover a tradezone
		 */
		highlightPoly(poly) {
			poly.setOptions({strokeColor: "#00ee00"});
			google.maps.event.addListener(poly,"mouseover",function() {
				poly.setOptions({strokeColor: "#ee0000"});
			});
			google.maps.event.addListener(poly,"mouseout",function() {
				poly.setOptions({strokeColor: "#00ee00"});
			});
		},
		polygonEffect(path, content, color='green', moreEffect = true) {
			let vm=this
			const editableOptions = !vm.subpaths ? {editable: true, draggable: false} : {}
			vm.selectedShape = vm.initPolygon(vm.map, path.coords, color, editableOptions);
			// Add a listener for the click tradezone event.
			google.maps.event.addListener(vm.selectedShape, 'click', (event) => {
				let bounds = new google.maps.LatLngBounds();
				path.coords.forEach(function(xy, i) {
					bounds.extend(xy);
				});
				vm.infoWindow.setContent(content);
				vm.infoWindow.setPosition(event.latLng);
				vm.infoWindow.open(vm.map, vm.selectedShape);
			});

			// Add a listener for mover over a tradezone
			vm.highlightPoly(vm.selectedShape);

			if(moreEffect) {
				vm.drawingManager.setDrawingMode(null);
				google.maps.event.addListener(vm.selectedShape, "rightclick", e => {
					// Check if click was on a vertex control point
					if (e.vertex == undefined) {
						return;
					}

					const contentDel = `<div id="content-delete-vertex">
						<button class="btn-danger" onclick="removeVertex()">Delete</button>
						</div>`;
					vm.infoWindow.setContent(contentDel);
					vm.infoWindow.setPosition(e.latLng);
					vm.infoWindow.open(vm.map, vm.selectedShape);
					vm.vertex = e.vertex;
					vm.polygon = path;
				});

				if(path && !vm._.isEmpty(path.coords)) {
					google.maps.event.addListener(vm.selectedShape.getPath(), "insert_at", vm.getPolygonCoords.bind(this, path));
					google.maps.event.addListener(vm.selectedShape.getPath(), "set_at", vm.getPolygonCoords.bind(this, path));
				}
			}
		},
		addMarker(location, info) {
			const contentString =
				`<div id="content-marker-outlet">
					<h4>Name: <strong>${info && info.name || ''}</strong></h4>
					<h4>Email: ${info && info.email || ''}</h4>
					<h4>Phone: ${info && info.phone || ''}</h4>
					<h4>Address: ${info && info.address || ''}</h4>
				</div>`;
			let marker = new google.maps.Marker({
				position: location,
				label: info.label || '',
				map: vm.map,
				icon: info.icon || ''
			});
			marker.addListener("click", () => {
				vm.infoWindow.setContent(contentString);
				vm.infoWindow.setPosition(location);
				vm.infoWindow.open(vm.map, marker);
			});

			return marker;
    },
    checkOverlap: async function (data = {coords: []}) {
      const response = await vm.axios.outlet.checkOverlapTradezone(data);
      return response && response.data && response.data.data && response.data.data.items ? response.data.data.items : [];
    },
    getStoreList () {
      let params = `?exclude_outlet_uuid=${this.$route.params.uuid}&active=1&isNotFullDetail=1&limit=99999`;
      vm.axios.outlet.getOutletList(params,
        {},
        function (response) {
          vm.outletList = response.data.data.items
        },
        function (error) {
          //your code
        })
    },
    getNearbyOutlets: async function(distance = 10) {
      let params =
        "?uuid=" +
        vm.outletUuid +
        "&distance=" + distance;
      
      const response = await vm.axios.outlet.getNearbyOutlets(params);
      return response && response.data && response.data.data && response.data.data.items ? response.data.data.items : [];
    },
    randomColor(colorNum, colors){
      if (colors < 1) colors = 1; // defaults to one color - avoid divide by zero
      return `hsl(${(colorNum * (360 / colors) % 360)},100%,50%)`;
    },
    closeMap: function () {
      this.$root.$emit('closeMap', 'none');
    },
    updateTradezone: async function(data) {
      const input = {
        uuid: vm.outletUuid,
        tradezone: data
      }
      const response = await vm.axios.outlet.updateTradezone(input);
      return response;
    },
    saveTradezone: async function () {
      const updateResult = await vm.updateTradezone(vm.paths);

      if (updateResult && updateResult.status) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.$bus.$emit('loading', 'none')
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        vm.$toastr.error(vm.$t('message.error'), vm.$t('message.error'), {});
        vm.$bus.$emit('loading', 'none');
      }      
    },
    drawNearbyOutlets: function () {
      // Nearby outlet's marker and tradezones
      let groupNearbyOutlet = vm._.groupBy(vm.nearbyOutlets || [], 'uuid');
      const nearbyOutletCount = Object.keys(groupNearbyOutlet).length || 1;
      let outletNumber = 0;
      for (let i in groupNearbyOutlet) {
        if(i != vm.outletUuid && groupNearbyOutlet[i] && groupNearbyOutlet[i][0]) {
          let otherMarker = vm.addMarker({
            lat : groupNearbyOutlet[i][0].lat,
            lng : groupNearbyOutlet[i][0].long
          },
          {
            ...groupNearbyOutlet[i][0],
            icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
          });
          vm.nearbyOutletsMarker.push(otherMarker);
          const color = vm.randomColor(outletNumber, nearbyOutletCount);
          groupNearbyOutlet[i].forEach((subpath = {}) => {
            const nearbyOutletTradezone = vm.initPolygon(vm.map, subpath.coords, color);
            // const content = `<div id="content-map-outlet">
            //   <h4>Tradezone ID:      <strong>${subpath.id}</strong></h4>
            //   <div class="mt-1 mb-1">
            //     <button class="btn-primary" onclick="viewListSubtradezone(${subpath.id})">View Subtradezones</button>
            //     <button class="btn-danger" onclick="removeTradezone(${subpath.id})">Delete</button>
            //   </div>
            // </div>`;
            // vm.polygonEffect(
            //   subpath,
            //   content,
            //   color
            // );
            vm.nearbyOutletsTradezones.push(nearbyOutletTradezone);
          });
        }
        outletNumber++;
      }
    }
  }
}
</script>

<style type="text/css" scoped>
#map,
html,
body {
  padding: 0;
  margin: 0;
  height: auto;
  min-height: 920px;
  width: auto;
}

#panel {
  width: 200px;
  font-family: Arial, sans-serif;
  font-size: 13px;
  float: right;
  margin: 10px;
}

#color-palette {
  clear: both;
}

.color-button {
  width: 14px;
  height: 14px;
  font-size: 0;
  margin: 2px;
  float: left;
  cursor: pointer;
}
#delete-button {
  margin-top: 5px;
}
</style>

<style type="text/css">
	#content-map-outlet .active-button {
		background-color: #0086FF;
		color: white;
	}

	#content-map-outlet .danger-button {
		background-color: #f86c6b;
		color: white;
	}
</style>



// WEBPACK FOOTER //
// src/views/admin/outlets/OutletsMap.vue